$(document).ready(function () {

    $("#QuickLookModal .SmallProductImages img").live("click", function () {
        var ImageIndex = $(this).index();
        $("#QuickLookModal .ProductDetailImages ul li").each(function () {
            if ($(this).index() == ImageIndex) {
                $(this).removeClass("gizli");
                $(this).find("a img").attr("src", $(this).find("a img").data("src"));
            }
            else {
                $(this).addClass("gizli");
            }


        });
        $("#QuickLookModal .SmallProductImages img").each(function () {
            if ($(this).index()==ImageIndex) {
                $(this).addClass("Selected");
            } else {
                $(this).removeClass("Selected");
            }


        });


    });

 
});